import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { site } from "@/mocks/site";

export default function Hero() {
  const top = articles.reduce((a, b) => (b.hot > a.hot ? b : a), articles[0]);

  return (
    <section className="relative w-full overflow-hidden bg-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
          <div className="animate-floatUp">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50 px-3.5 py-1.5 text-xs font-label text-primary-700">
              <i className="ri-fire-line" />
              {site.updateNote}
            </span>
            <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
              一键吃瓜，
              <br className="hidden sm:block" />
              秒开速览不跳转
            </h1>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              {site.intro}
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <Link
                to="/hot"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-flashlight-line" />
                立即看今日热榜
              </Link>
              <Link
                to="/topics"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-label text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
              >
                <i className="ri-layout-grid-line" />
                浏览内容专题
              </Link>
            </div>

            <ul className="mt-9 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {[
                { no: "01", title: "先看结论", desc: "重点写在前三行" },
                { no: "02", title: "再看脉络", desc: "一场话题的来龙去脉" },
                { no: "03", title: "最后收藏", desc: "无跳转，读完即走" },
              ].map((step) => (
                <li key={step.no} className="rounded-card border border-background-200 bg-background-50 p-4">
                  <span className="font-heading text-lg font-bold text-accent-600">{step.no}</span>
                  <p className="mt-1 font-heading text-sm font-semibold text-foreground-950">{step.title}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">{step.desc}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative w-full animate-floatUp">
            <div className="relative w-full overflow-hidden rounded-card" style={{ aspectRatio: "4 / 3" }}>
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20glossy%20stage%20lights%2C%20warm%20amber%20and%20crimson%20spotlights%2C%20dramatic%20bokeh%2C%20dark%20moody%20gradient%20background%2C%20cinematic%20no%20text&width=1200&height=900&seq=hero-hl-01&orientation=landscape"
                alt="暖色调舞台灯光抽象背景，代表娱乐话题速览站的氛围"
                title="黑料在线 · 娱乐话题速览"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <p className="text-xs font-label tracking-widest text-background-200">TODAY&apos;S TOP</p>
                <h2 className="mt-2 font-heading text-lg font-bold leading-snug text-background-50 md:text-xl">
                  {top.title}
                </h2>
                <div className="mt-3 flex flex-wrap items-center gap-2 text-xs text-background-200">
                  <span className="rounded-full bg-background-50/20 px-2.5 py-1">{top.categoryName}</span>
                  <span className="rounded-full bg-background-50/20 px-2.5 py-1">
                    <i className="ri-fire-line mr-1" />
                    热度 {top.hot}
                  </span>
                </div>
              </div>
            </div>

            <div className="absolute -left-2 top-6 hidden rounded-card border border-background-200 bg-background-50 p-3.5 sm:block md:-left-6">
              <p className="text-[11px] font-label text-foreground-500">单篇读完</p>
              <p className="font-heading text-xl font-bold text-primary-600">90 秒</p>
            </div>
            <div className="absolute -bottom-4 right-2 hidden rounded-card border border-background-200 bg-background-50 p-3.5 sm:block md:right-4">
              <p className="text-[11px] font-label text-foreground-500">今日新增话题</p>
              <p className="font-heading text-xl font-bold text-accent-600">+18</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}